$(document).ready(function () {
  $(".filter-checkbox")
    .off()
    .change(function () {
      var newURL = $(this).nextAll("a").attr("href");
      window.location.href = newURL;
    });

  const sortArray = (array) => {
    array = array.sort((a, b) => a - b);
    return array;
  };
  const groupBySizeRegion = (filters) => {
    let objectNumber = {};
    filters.forEach((filter) => {
      let splitFilter = (filter != 'One Size') ? filter.split(" ") : ['one-size'],
        sizeType =
          splitFilter.length == 2
            ? splitFilter[0]
            : splitFilter.length == 3
              ? `${splitFilter[0]} ${splitFilter[1]}`
              : splitFilter.length == 1
                ? `Size`
                : null,
        sizeNumber =
          splitFilter.length == 2
            ? splitFilter[1]
            : splitFilter.length == 3
              ? splitFilter[2]
              : splitFilter.length == 1
                ? splitFilter[0]
                : null;
      if (typeof objectNumber[sizeType] === "undefined") {
        objectNumber[sizeType] = [sizeNumber];
        // console.log('sizeNumber1', sizeNumber);
      } else {
        objectNumber[sizeType] = [...objectNumber[sizeType], sizeNumber];
        // console.log('sizeNumber2', sizeNumber);
        // console.log('objectNumber[sizeType] 2', sizeType, objectNumber[sizeType]);
      }
    });

    // console.log('objectNumber', objectNumber);
    return objectNumber;
  };
  const getFilterWithLetter = (filters) => {
    filters = filters.filter((filter) => {
      let splitFilter = filter.split(" "),
        sizeNumber = parseFloat(splitFilter[1]);
      if (sizeNumber != splitFilter[1]) return filter;
    });
    return filters;
  };
  const getFilterNumber = (filters) => {
    filters = filters.filter((filter) => {
      let splitFilter = filter.split(" "),
        sizeNumber = parseFloat(splitFilter[1]);
      if (sizeNumber == splitFilter[1]) return filter;
    });
    return filters;
  };
  const getSortedFilterNumber = (filterNumber) => {
    let objectNumber;
    if (filterNumber.length > 0) {
      objectNumber = groupBySizeRegion(filterNumber);
      for (item in objectNumber) {
        objectNumber[item] = objectNumber[item].map((val) => {
          return parseFloat(val);
        });
        objectNumber[item] = sortArray(objectNumber[item]);
      }
      return objectNumber;
    }
  };
  const getSortedFilterWithLetter = (filterNumberLetter) => {
    let objectNumberLetter;
    if (filterNumberLetter.length > 0) {
      objectNumberLetter = groupBySizeRegion(filterNumberLetter);
      for (item in objectNumberLetter) {
        let newGroup = {};
        objectNumberLetter[item].forEach((val) => {
          let lastChar = val[val.length - 1],
            isContainLetter = isNaN(parseFloat(lastChar)) ? true : false;
          if (isContainLetter) {
            //       	newArray = [...newArray, [val.replace(lastChar, ""), lastChar]]
            if (typeof newGroup[lastChar] === "undefined") {
              newGroup[lastChar] = [val];
            } else {
              newGroup[lastChar] = [...newGroup[lastChar], val];
            }
          }
        });
        if (Object.keys(newGroup).length > 0) {
          let keyLetter = [];
          for (key in newGroup) {
            keyLetter = [...keyLetter, key];
          }
          keyLetter.sort();
          let sortNewGroup = {};
          keyLetter.forEach((index) => {
            sortNewGroup[index] = newGroup[index];
          });
          for (key in sortNewGroup) {
            sortNewGroup[key] = sortNewGroup[key].map((valNewgroup) => {
              let lastChar = valNewgroup[valNewgroup.length - 1];
              return [valNewgroup.replace(lastChar, ""), lastChar];
            });
            sortNewGroup[key] = sortNewGroup[key].sort(
              (a, b) => parseFloat(a[0]) - parseFloat(b[0])
            );
            sortNewGroup[key] = sortNewGroup[key].map((valNewgroup) => {
              let lastChar = valNewgroup[valNewgroup.length - 1];
              return `${valNewgroup[0]}${valNewgroup[1]}`;
            });
          }
          objectNumberLetter[item] = sortNewGroup;
        } else {
          objectNumberLetter[item] = objectNumberLetter[item].map((val) => {
            return parseFloat(val);
          });
          objectNumberLetter[item] = sortArray(objectNumberLetter[item]);
        }
      }
    }
    return objectNumberLetter;
  };
  const concatObject = (objectNumber, objectNumberLetter) => {
    if (typeof objectNumber !== "undefined") {
      if (Object.keys(objectNumber).length > 0) {
        for (key in objectNumber) {
          if (typeof objectNumberLetter !== "undefined") {
            if (Object.keys(objectNumberLetter).length > 0) {
              for (index in objectNumberLetter) {
                if (key === index) {
                  if (Array.isArray(objectNumberLetter[index])) {
                    objectNumber[key] = objectNumber[key].concat(
                      objectNumberLetter[index]
                    );
                  } else {
                    for (idx in objectNumberLetter[index]) {
                      objectNumber[key] = objectNumber[key].concat(
                        objectNumberLetter[index][idx]
                      );
                    }
                  }
                } else {
                  if (typeof objectNumber[index] === "undefined") {
                    objectNumber[index] = objectNumberLetter[index];
                  }
                }
              }
            }
          }
        }
      }
    } else if (typeof objectNumberLetter !== "undefined") {
      if (Object.keys(objectNumberLetter).length > 0) {
        return objectNumberLetter;
      }
    }
    return objectNumber;
  };
  const appendFilter = (concatedObject, obj, sizeType, currentUrl) => {
    let objectHTML = concatedObject[obj].map((item) => {
      let itemUrl = item
        .toString()
        .replaceAll(" ", "-")
        .replaceAll(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-");
      let filterHTML;
      if (obj == "BR") {
        filterHTML = `
                  <li class="filter-item size-digit-keatas size-${obj}-${item}">
                    <a href="${currentUrl}/size-${sizeType}-${itemUrl}-${parseFloat(item) + 1
          }" title="Narrow selection to products matching tag size-${sizeType} ${item}/${parseFloat(item) + 1
          }">${obj} ${item}/${parseFloat(item) + 1}</a>    
                  </li>	
              `;
      } else {
        if (sizeType.toLowerCase() != "size") {
          filterHTML = `
            <li class="filter-item size-digit-keatas size-${obj}-${item}">
                <a href="${currentUrl}/size-${sizeType}-${itemUrl}" title="Narrow selection to products matching tag size-${sizeType} ${item}">${obj} ${item}</a>    
            </li>	
        `;
        } else {
          if (item != 0) {
            filterHTML = `
                    <li class="filter-item size-digit-keatas selain-size">
                        <a href="${currentUrl}/size-${itemUrl}" title="Narrow selection to products matching tag size ${item}">${item}</a>    
                    </li>	
                `;
          }
        }
      }
      return filterHTML;
    });
    return objectHTML;
  };

  const getObjectNumberFilter = (filterNumber) => {
    let ObjectNumber = {};
    let key = '';
    let arrValue = [];

    filterNumber.forEach((number) => {
      splitNumber = number.split(' ');
      key = splitNumber[0];
      arrValue.push(splitNumber[1]);
    });

    ObjectNumber[key] = arrValue;
    return ObjectNumber;
  };

  const getObjectLetterFilter = (filterLetter) => {
    const ORDER = ['one size', 'xxs', 'xs', 's', 'm', 'l', 'xl', '2xl', 'xxl'];
    filterLetter.sort((a, b) => {
      a = a.toLowerCase();
      b = b.toLowerCase();
      return ORDER.indexOf(a) - ORDER.indexOf(b);
    });
    return { 'Size': filterLetter };
  };

  let currentUrl = location.protocol + "//" + location.host + location.pathname,
    currentUrlSplit = currentUrl.split("/");
  currentUrl =
    currentUrlSplit.length > 5
      ? location.protocol +
      "//" +
      location.host +
      "/" +
      currentUrlSplit[3] +
      "/" +
      currentUrlSplit[4]
      : currentUrl;
  if (
    location.pathname.includes("collections") &&
    !location.pathname.includes("products")
  ) {
    let filters = [];
    size.forEach((val) => {
      filters = [...filters, val];
    });
    // console.log(size);
    filters = filters.map((item) => {
      if (item.split(" ") > 1) {
        return `Size ${item}`;
      } else {
        return item;
      }
    });
    let filterNumber = getFilterNumber(filters);
    let filterNumberLetter = getFilterWithLetter(filters);

    // console.log('filternumber', filterNumber);
    // console.log('filterNumberLetter', filterNumberLetter);

    let objectNumber = getSortedFilterNumber(filterNumber);
    let objectNumberLetter = getSortedFilterWithLetter(filterNumberLetter);

    // console.log('objectNumber', objectNumber);
    // console.log('objectNumberLetter', objectNumberLetter);

    // let concatedObject = concatObject(objectNumber, objectNumberLetter);
    let concatedObject = { ...objectNumber, ...getObjectLetterFilter(filterNumberLetter) };
    let containerFilterHTML = `
      <ul class="filter-list 2digit_keatas duakeatas type-us">
      </ul>
    `;
    $("#sizeFilterna .filter-panel").append(containerFilterHTML);

    for (obj in concatedObject) {
      let sizeType = obj
        .replaceAll(" ", "-")
        .replaceAll(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-"),
        objectHTML;

      // console.log('obj', obj);
      // console.log('Array.isArray', Array.isArray(concatedObject[obj]));
      // console.log('concatedObject', concatedObject);
      // console.log('sizeType', sizeType, obj);
      // objectHTML = appendFilter(concatedObject, obj, sizeType, currentUrl);

      if (Array.isArray(concatedObject[obj])) {

        objectHTML = appendFilter(concatedObject, obj, sizeType, currentUrl);
        if (obj == "Size" && window.location.pathname.includes("bags-1")) {
          $("#filterClothing .filter-title").text("Accessories Size");
        }
        if (
          obj === "Size" &&
          window.location.pathname.includes("accessories-1")
        ) {
          $("#filterClothing .filter-title").text("Accessories Size");
        }
        if (obj === "Size" && window.location.pathname.includes("apparel")) {
          $("#filterClothing .filter-title").text("Clothing Size");
        }
        if (obj == "UK" || obj == "US" || obj == "US W") {
          $("#filterTitlena").text("Size");
        }
        $("#sizeFilterna .filter-panel ul.filter-list").append(objectHTML.join("\n"));
      }
      else {
        for (key in concatedObject[obj]) {
          objectHTML = concatedObject[obj][key].map((item) => {
            let itemUrl = item
              .toString()
              .replaceAll(" ", "-")
              .replaceAll(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-");
            let filterHTML;
            if (obj == "BR") {
              filterHTML = `
                    <li class="filter-item size-digit-keatas size-${item}">
                      <a href="${currentUrl}/size-${sizeType}-${itemUrl}-${parseFloat(item) + 1
                }" title="Narrow selection to products matching tag size-${sizeType} ${item}/${parseFloat(item) + 1
                }">${obj} ${item}/${parseFloat(item) + 1}</a>    
                    </li>	
                `;
            } else if (obj == "NS") {
              console.log("tesss");
            }
            else {
              if (sizeType.toLowerCase() != "size") {
                filterHTML = `
                      <li class="filter-item size-digit-keatas size-${item}" >
                          <a href="${currentUrl}/size-${sizeType}-${itemUrl}" title="Narrow selection to products matching tag size-${sizeType} ${item}">${obj} ${item}</a>    
                      </li>	
                  `;
              } else {
                if (item != 0) {
                  filterHTML = `
                      <li class="filter-item size-digit-keatas selain-size" >
                          <a href="${currentUrl}/size-${itemUrl}" title="Narrow selection to products matching tag size ${item}">${item}</a>    
                      </li>	
                  `;
                }
              }
            }
            return filterHTML;
          });

          $("#filterClothing .filter-panel .filter-list").append(
            `${objectHTML.join("\n")}`
          );
        }
      }
    }
  }


  var min = $('input[name="filter.v.price.gte"]').val();
  if (min == '') {
    min = 0;
  }
  var max = $('input[name="filter.v.price.lte"]').val();
  if (max == '') {
    max = $('input[name="filter.v.price.gte"]').attr('max');
  }

  var fixed_max = $('input[name="filter.v.price.gte"]').attr('max');
  var parts = window.location.href.split('?')[0].split('/');
  var lastSegment = parts.pop() || parts.pop();  // handle potential trailing slash
  var isFiltered = parts.length == 5 && parts[4];

  if ($('.filter-item.cat').length > 0 && isFiltered) {

    $('.filter-item.cat').each(function (i, v) {
      let input_check = $(v).children('.filter-cat');

      if (lastSegment.indexOf(input_check.data('value')) != -1) {
        input_check.prop('checked', true);
        // $(this).removeClass('disabled');
      } else {
        // input_check.attr('disabled', true);
        // $(this).addClass('disabled');
      }
    });
  }

  $('.filter-item.cat').click(function () {
    if ($(this).hasClass('disabled')) {
      return;
    }

    var click_value = $(this).children('.filter-cat').data('value');

    if ($(this).children('.filter-cat').is(':checked')) {
      var new_url = isFiltered
        ? lastSegment + '+' + click_value
        // ? lastSegment.replace(lastSegment, click_value)
        : lastSegment + '/' + click_value;

      window.location.href = new_url;

      console.log('click 3', new_url);
    } else {
      if (lastSegment.indexOf($(this).children('.filter-cat').data('value')) != -1) {
        let link = window.location.href;
        let param_filter = $(this).children('.filter-cat').data('value');
        let new_url = link.indexOf('/' + param_filter) != -1
          ? link.replace('/' + param_filter, '')
          : link.replace('+' + param_filter, '');
        // let new_url = link.replace('/' + $(this).children('.filter-cat').data('value'), '');
        console.log('new_url', new_url, '/' + $(this).children('.filter-cat').data('value'));

        window.location.href = new_url;
      }

      console.log('click 4', lastSegment);
    }
  });

  // $('.filter-cat').change(function () {
  //   if ($(this).hasClass('disabled')) {
  //     return;
  //   }

  //   if (this.checked) {
  //     var click_value = $(this).data('value');
  //     var new_url = isFiltered
  //       ? lastSegment + '+' + click_value
  //       : lastSegment + '/' + click_value;

  //     // window.location.href = new_url;
  //     console.log('click 1');
  //   } else {
  //     console.log('click 2');
  //     console.log('lastSegment', lastSegment);
  //   }
  // });

  $('#flat-slider').slider({
    orientation: 'horizontal',
    range: true,
    animate: true,
    min: 0,
    max: Number(fixed_max),
    values: [Number(min), Number(max)],
    slide: function (event, ui) {
      if ((ui.values[1] - ui.values[0]) < 1) {
        return false;
      }

      $('input[name="filter.v.price.gte"]').val(ui.values[0])
      $('input[name="filter.v.price.lte"]').val(ui.values[1])
      window.location.href = window.location.href.split('?')[0] + '?filter.v.price.gte=' + ui.values[0] + '&filter.v.price.lte=' + ui.values[1]
      console.log(window.location.href);
    }
  });



});